<div class="checkbox-container" [tcTooltip]="tooltipText" [placement]="tooltipPlacement">
    <label class="input-control checkbox small-check" [ngClass]="{ 'disabled-chk': inputIsDisabled }">
        <input
            type="checkbox"
            [(ngModel)]="_innerValue"
            (ngModelChange)="onChange($event)"
            [disabled]="inputIsDisabled"
            [indeterminate]="_isIndeterminate"
            id="{{ _id }}"
        />
        <span class="check" [ngClass]="{ invalid: !isValid }"></span>
        <span *ngIf="inputIcon" class="checkbox-icon" [ngClass]="inputIcon"></span>
        <span *ngIf="inputCaption">{{ inputCaption }}</span>
    </label>
</div>
